import { useMemo, useRef, useState } from 'react';
import React from 'react';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import { Col, LoadingTip, Row } from 'tea-component';
import { getLocale, useIntl } from 'umi';
import { mdContentToHtml } from '@op/utils/text';
import './mdShow.scss';
import DOMPurify from 'dompurify';

export default function MDShow({
  mdFileMap,
}: {
  mdFileMap: { [key: string]: string };
}) {
  const [loading, setLoading] = useState(true);
  const { formatMessage } = useIntl();

  const renderContent = (text: string) => {
    setLoading(true);
    const { html } = mdContentToHtml(text);
    setLoading(false);
    return html;
  };

  const markdownRef = useRef<HTMLDivElement | null>(null);

  const mdFileText = useMemo(() => {
    let la = getLocale();
    return renderContent(mdFileMap[la]);
  }, [formatMessage]);

  return (
    <>
      {!loading ? (
        <CardSlot>
          <Row>
            <Col span={24}>
              <div
                className="markdown-body md-text-box"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(mdFileText) }}
                ref={markdownRef}
              ></div>
            </Col>
          </Row>
        </CardSlot>
      ) : (
        <LoadingTip
          loadingText=""
          style={{
            marginLeft: '48%',
            position: 'relative',
            marginTop: '30%',
          }}
        />
      )}
    </>
  );
}
